import ProductPickupPointInfo from "./ProductPickupPointInfo"

const OrderedFieldDisplayRow = ({ orderedField }) => {
  const { product_order_field, value } = orderedField

  if (product_order_field == null) {
    return
  }

  if (value == null) {
    return product_order_field.name
  }

  switch (product_order_field.type) {
    case "ProductOrderField::Boolean":
      return (
        <span>{product_order_field.frontend_name}: {value ? I18n.t("base.yes") : I18n.t("base.no")}</span>
      )
    case "ProductOrderField::List":
    case "ProductOrderField::Geopoint":
      return (
        <span>{product_order_field.frontend_name}: {value.name}</span>
      )
    case "ProductOrderField::PickupPoint":
      let name = orderedField.value.name
      if (orderedField.value.pickup_point_option.pickup_point_type === "predefined") {
        name = <ProductPickupPointInfo point={orderedField.value.pickup_point_option.product_pickup_point} />
      }
      return (
        <span>
          {product_order_field.frontend_name}: {name}
        </span>
      )
    case "ProductOrderField::Country":
      let c = value && st.COUNTRIES.find(c => c[0] === value)
      return (
        <span>{product_order_field.frontend_name}: {c ? c[1] : null}</span>
      )
    default:
      return (
        <span>{product_order_field.frontend_name}: {value}</span>
      )
  }
}

export default class SidebarSectionOrder extends React.Component {
  renderProductAttributes() {
    return (
      <div className="pricelist-item pricelist-item--product" key="product">
        {this.props.order.data.product_variant_name && (
          <p>{this.props.order.data.product_variant_name}</p>
        )}

        {this.props.order.data.coupon_offer_price_before_discount && (
          <div className="pricelist-row SidebarSectionOrder-coupon_offer_price_before_discount">
            <div className="pricelist-row-name">
              {I18n.t("fe.order_details.coupon_offer_price_before_discount")}
            </div>
            <div className="pricelist-row-value">
              {st.formatMoney(this.props.order.data.coupon_offer_price_before_discount)}
            </div>
          </div>
        )}

        {(this.props.order.data.coupon_discount_amount || this.props.order.data.coupon_discount_percentage) && (
          <div className="pricelist-row SidebarSectionOrder-coupon_discount_amount">
            <div className="pricelist-row-name">
              {I18n.t("fe.order_details.coupon_discount_amount")}
            </div>
            <div className="pricelist-row-value">
              {(() => {
                const formattedAmount = this.props.order.data.coupon_discount_amount && st.formatMoney(this.props.order.data.coupon_discount_amount)
                const formattedPercentage = this.props.order.data.coupon_discount_percentage && `${this.props.order.data.coupon_discount_percentage}%`
                if (formattedAmount && formattedPercentage) {
                  return `${formattedAmount} (${formattedPercentage})`
                } else {
                  return formattedAmount || formattedPercentage
                }
              })()}
            </div>
          </div>
        )}

        {this.props.order.data.coupon_offer_price && (
          <div className="pricelist-row pricelist-row--bold SidebarSectionOrder-coupon_offer_price">
            <div className="pricelist-row-name">
              {I18n.t("fe.order_details.coupon_offer_price")}
            </div>
            <div className="pricelist-row-value">
              <strong className="text-primary">
                {st.formatMoney(this.props.order.data.coupon_offer_price)}
              </strong>
            </div>
          </div>
        )}

        {(this.props.order.data.coupon_discount_amount || this.props.order.data.coupon_discount_percentage || this.props.order.data.coupon_offer_price) && (
          <br />
        )}

        {!!this.props.order.data.stock_starts_at &&
          <p>{I18n.t("attributes.stock_time_range")}: {st.formatTimeRange(this.props.order.data.stock_starts_at, this.props.order.data.stock_ends_at, { includeTime: this.props.order.data.stock_includes_time })}</p>
        }

        {!!(this.props.order.data.stock_useby_starts_at || this.props.order.data.stock_useby_ends_at) &&
          <p>{I18n.t("attributes.stock_useby_time_range")}: {st.formatTimeRange(this.props.order.data.stock_useby_starts_at, this.props.order.data.stock_useby_ends_at, { includeTime: false })}</p>
        }

        {!!this.props.order.data.persons_count && (
          <p>{I18n.t("attributes.persons_count")}: {this.props.order.data.persons_count}</p>
        )}
      </div>
    )
  }

  renderOrderedProductPricelistItems() {
    return (this.props.order.data.order_items || []).map((orderItem, i) => (
      <div className="pricelist-item pricelist-item--order_item" key={i}>
        <div className="pricelist-row">
          <div className="pricelist-row-name">
            {orderItem.quantity} x {orderItem.name}
          </div>
          <div className="pricelist-row-value">
            {st.formatMoney(st.exchangeMoney(orderItem.total_price, this.props.order.data.customer_conversion_currency))}
          </div>
        </div>
      </div>
    ))
  }

  renderPricelistTotalAmount() {
    return !!this.props.order.data.total_amount_sum && this.props.order.data.total_amount_sum.length > 0 && (
      <div className="pricelist-item pricelist-item--total_amount">
        <div className="pricelist-row">
          <div className="pricelist-row-name">
            {I18n.t("fe.order_details.to_be_paid_total_amount")}
          </div>
          <div className="pricelist-row-value">
            {st.formatMoney( st.exchangeMoney(this.props.order.data.total_amount_sum, this.props.order.data.customer_conversion_currency) )}
          </div>
        </div>
      </div>
    )
  }

  renderPricelistTransfers() {
    return !!this.props.order.data.order_transfers && this.props.order.data.order_transfers.map((transfer, i) => (
      <div className="pricelist-item pricelist-item--transfer" key={i}>
        <div className="pricelist-row">
          <div className="pricelist-row-name">
            {transfer.name}
          </div>
          <div className="pricelist-row-value">
            {st.formatMoney( st.exchangeMoney(transfer.amount, this.props.order.data.customer_conversion_currency), transfer.transaction_amount )}
          </div>
        </div>
      </div>
    ));
  }

  renderPricelistInstallments() {
    return !!this.props.order.data.installments && this.props.order.data.installments.map((installment, i) => (
      <div className="pricelist-item pricelist-item--installment" key={i}>
        <div className="pricelist-row">
          <div className="pricelist-row-name">
            {installment.name}
          </div>
          <div className="pricelist-row-value">
            {st.formatMoney( installment.frontend_amount )}
          </div>
        </div>

        {!!installment.frontend_sub_name && [
          <div className="pricelist-row pricelist-row--sub" key="sub">
            <div className="pricelist-row-name">
              {installment.frontend_sub_name}
            </div>
            <div className="pricelist-row-value">
              {st.formatMoney( installment.frontend_sub_amount )}
            </div>
          </div>
          ,
          <div className="pricelist-hint" key="hint" dangerouslySetInnerHTML={{__html: installment.frontend_sub_hint_html}}></div>
        ]}
      </div>
    ));
  }

  renderOrderDetails() {
    const hasFilledInOrderedField = [
      ...this.props.order.data.ordered_product_order_fields
        .filter(orderedField => orderedField.visible && !!orderedField.value),
      ..._.flatten(this.props.order.data.order_customer_participants.map(participant => (
        participant.ordered_product_order_fields
          .filter(orderedField => orderedField.visible && !!orderedField.value)
      )))
    ].length > 0

    return hasFilledInOrderedField && (
      <div className="order-customer-data">
        <h4>{I18n.t("fe.sidebar_section_order.order_details")}</h4>
        <ul className="ordered_product_order_fields">
          {this.props.order.data.ordered_product_order_fields
            .filter(orderedField => orderedField.visible && !!orderedField.value)
            .map((orderedField, j) => (
              <li key={j}><OrderedFieldDisplayRow orderedField={orderedField} /></li>
            ))
          }
        </ul>

        {this.props.order.data.order_customer_participants && this.props.order.data.order_customer_participants.length > 0 && (
          <div className="order_customer_participants">
            <h5>{I18n.t("attributes.order_customer_participants")}</h5>
            <ol>
              {this.props.order.data.order_customer_participants.map((participant, i) => (
                <li key={i}>
                  {participant.display_name}
                  <ul className="ordered_product_order_fields">
                    {participant.ordered_product_order_fields
                      .filter(orderedField => orderedField.visible && !!orderedField.value)
                      .map((orderedField, j) => (
                        <li key={j}><OrderedFieldDisplayRow orderedField={orderedField} /></li>
                      ))
                    }
                  </ul>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    );
  }

  renderCancellationPolicy() {
    return this.props.order.data.cancellation_policy && (
      <div className="SidebarSectionOrder-cancellation_policy">
        <h4>{I18n.humanAttributeName("order", "cancellation_policy")}</h4>
        <p>{this.props.order.data.cancellation_policy}</p>
      </div>
    )
  }

  renderAdditionalInformation() {
    return this.props.order.data.additional_information && (
      <div className="SidebarSectionOrder-additional_information">
        <h4>{I18n.humanAttributeName("order", "additional_information")}</h4>
        <p>{this.props.order.data.additional_information}</p>
      </div>
    )
  }

  render() {
    return (
      <div className="section NewOrderView-sidebar-section section-order">
        <h2 className="section-title">{I18n.t("fe.sidebar_section_order.title")}</h2>

        <div className="section-content">
          <div className="pricelist">
            {this.renderProductAttributes()}
            {this.props.order.data.product_type === "standard" && this.renderOrderedProductPricelistItems()}
            {this.props.order.data.product_type === "standard" && this.renderPricelistTotalAmount()}
            {this.props.order.data.product_type === "standard" && this.renderPricelistTransfers()}
            {this.props.order.data.product_type === "standard" && this.renderPricelistInstallments()}
            {this.renderCancellationPolicy()}
            {this.renderAdditionalInformation()}
          </div>

          {!!this.props.showOrderDetails && this.renderOrderDetails()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/SidebarSectionOrder.jsx